export const SET_SIZE = "@@screen/SET_SIZE";
